// BetDataTable
/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnEstadistica(game_id, is_premium) {
  window.app.__vue__.$gtm.push({ event: 'click_btn_estadistica', game_id, is_premium });
}

/**
 * @author Fernando Mellone
 * @param {Boolean} value
 * @param {Boolean} is_premium
 * @param {Number} game_id
 * @return {{}}
 */

export function clickInputTipsInversion(value, is_premium, game_id) {
  let event = { event: 'click_input_tips_inversion', value, is_premium, game_id };

  window.app.__vue__.$gtm.push(event);
}

// TipsAnalysis
/**
 * @author Fernando Mellone
 * @param {Boolean} value
 * @param {Boolean} is_premium
 * @return {{}}
 */
export function clickBtnQuepasariasi(is_premium, value) {
  let event = {
    event: 'click_btn_quepasariasi',
    is_premium,
  };

  if (value !== undefined) event = { ...event, value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} value
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickSwtichTipsQuepasariasi(is_premium, value) {
  let event = { event: 'click_swtich_tips_quepasariasi', is_premium };

  if (value !== undefined) event = { ...event, value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnTipsRentabilidad(is_premium) {
  let event = { event: 'click_btn_tips_rentabilidad', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// MessagePremium
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnPopupLogin(is_premium) {
  let event = { event: 'click_btn_popup_login', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnPopupCrearCuenta(is_premium) {
  let event = { event: 'click_btn_popup_crear_cuenta', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnPopupCerrar(is_premium) {
  let event = { event: 'click_btn_popup_cerrar', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// AdvanceFilter
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @param {Number} game_id
 * @return {{}}
 */

export function clickBtnAplicarFiltros(is_premium, game_id) {
  let event = { event: 'click_btn_aplicar_filtros', is_premium, game_id };

  window.app.__vue__.$gtm.push(event);
}

// ItemNextMatches
/**
 * @author Fernando Mellone
 * @param {String} event_name
 * @param {Boolean} is_premium
 * @param {Boolean} is_live
 * @param {Number} game_id
 * @return {{}}
 */

export function ItemNextMatchesSelect(event_name, is_premium, is_live, game_id) {
  let event = { event: `click_btn_${event_name}`, is_premium, is_live, game_id };

  window.app.__vue__.$gtm.push(event);
}

// ProfileSidebar
/**
 * @author Fernando Mellone
 * @param {String} route_event
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function ProfileSidebarGoTo(route_event, is_premium) {
  let event = { event: route_event, is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @param {Number} game_id
 * @return {{}}
 */

export function clickBtnCrearCuenta(is_premium) {
  let event = { event: 'click_btn_crear_cuenta', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnLogin(is_premium) {
  let event = { event: 'click_btn_login', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnLogout(is_premium) {
  let event = { event: 'click_btn_logout', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// TipsFilter
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @param {String} value
 * @return {{}}
 */

export function clickSelectTipsRiesgo(is_premium, value) {
  let event = { event: 'click_select_tips_riesgo', value, is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @param {Number} value
 * @return {{}}
 * Included in SetBetAmount
 */

export function clickInputTipsMontoTotalApostar(is_premium, value) {
  let event = { event: 'click_input_tips_monto_total_apostar', value, is_premium };

  window.app.__vue__.$gtm.push(event);
}

// Video
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickVideoFlujoCuentaPausa(is_premium) {
  let event = { event: 'click_video_flujo_cuenta_pausa', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickVideoFlujoCuentaPlay(is_premium) {
  let event = { event: 'click_video_flujo_cuenta_play', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// DesktopMenuNextMatches
/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @return {{}}
 */

export function btnVolver(game_id) {
  let event = { event: 'btn_volver', game_id };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} value
 * @return {{}}
 */

export function btnLive(game_id, value) {
  let event = { event: 'btn_live', game_id, value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_live
 * @param {Boolean} is_premium
 * @param {String} value
 * @return {{}}
 * Included in MobileMenuNextMatches
 */

export function clickSelectTipoDeApuesta(game_id, is_live, value, is_premium) {
  let event = { event: 'click_select_tipo_de_apuesta', game_id, is_live, value };

  if (is_premium !== undefined) event.is_premium = is_premium;

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_live
 * @param {Boolean} is_premium
 * @return {{}}
 * Included in MobileMenuNextMatches
 */

export function clickBtnAvanzado(game_id, is_live, is_premium) {
  let event = { event: 'click_btn_avanzado', game_id, is_live };

  if (is_premium !== undefined) event.is_premium = is_premium;

  window.app.__vue__.$gtm.push(event);
}

// TendenciaLive
/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_live
 * @param {String} value
 * @return {{}}
 */

export function clickSwitchTendenciaLiveEquipo(game_id, is_live, value) {
  let event = { event: 'click_switch_tendencia_live_equipo', game_id, is_live, value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_live
 * @param {String} value
 * @return {{}}
 */

export function clickSelectTendenciaLiveSelectorEstadistica(game_id, is_live, value) {
  let event = { event: 'click_select_tendencia_live_selector_estadistica', game_id, is_live, value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @param {Boolean} is_live
 * @param {String} value
 * @return {{}}
 */

export function clickSelectTendenciaLiveSelectorTipoVista(game_id, is_live, value) {
  let event = { event: 'click_select_tendencia_live_selector_tipo_vista', game_id, is_live, value };

  window.app.__vue__.$gtm.push(event);
}

// ChooseRisk
/**
 * @author Fernando Mellone
 * @param {Number} value
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnEligeRiesgoSiguiente(value, is_premium) {
  let event = { event: 'click_btn_elige_riesgo_siguiente', value, is_premium };

  window.app.__vue__.$gtm.push(event);
}

// Home
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnBienvenidoLograrGanancia(is_premium) {
  let event = { event: 'click_btn_bienvenido_lograr_ganancia', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// Matches
/**
 * @author Fernando Mellone
 * @param {Number} game_id
 * @return {{}}
 */

export function clickBtnPartido(game_id) {
  let event = { event: 'click_btn_partido', game_id };

  window.app.__vue__.$gtm.push(event);
}

// SetBetAmount
/**
 * @author Fernando Mellone
 * @param {Number} value
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnMontoSiguiente(value, is_premium) {
  let event = { event: 'click_btn_monto_siguiente', value, is_premium };

  window.app.__vue__.$gtm.push(event);
}

// SetBetUser
/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnCamnioUsuarioPremium(is_premium) {
  let event = { event: 'click_btn_camnio_usuario_premium', is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} is_premium
 * @return {{}}
 */

export function clickBtnCaminoUsuarioFree(is_premium) {
  let event = { event: 'click_btn_camino_usuario_free', is_premium };

  window.app.__vue__.$gtm.push(event);
}

// CardForm
/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnFlujoCuentaFinalizarCompra() {
  let event = { event: 'click_btn_flujo_cuenta_finalizar_compra' };

  window.app.__vue__.$gtm.push(event);
}

// Auth/Index
/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnFlujoCuentaCerrar() {
  let event = { event: 'click_btn_flujo_cuenta_cerrar' };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnFlujoCuentaIniciarSesionP() {
  let event = { event: 'click_btn_flujo_cuenta_iniciar_sesion_p' };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnFlujoCuentaCrearCuentaP() {
  let event = { event: 'click_btn_flujo_cuenta_crear_cuenta_p' };

  window.app.__vue__.$gtm.push(event);
}

// Login
/**
 * @author Fernando Mellone
 * @return {{}}
 */
export function clickEstadisticaTipoDeApuestaVerInformacion(is_premium, preview_section, golstats) {
  let event = { event: `ver_mas_informacion_de_estadisticas`, is_premium, preview_section, golstats };
  window.app.__vue__.$gtm.push(event);
}
export function clickBtnFlujoIniciarSesion(value, is_premium) {
  let event = { event: 'click_btn_flujo_iniciar_sesion', value, is_premium };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickLogin() {
  let event = { event: 'login' };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnFlujoCuentaCrearUna() {
  let event = { event: 'click_btn_flujo_cuenta_crear_una' };

  window.app.__vue__.$gtm.push(event);
}

export function clickOlvidasteLaContrasena(is_premium, golstats) {
  let event = { event: `recuperar_contraseña`, is_premium, golstats };

  window.app.__vue__.$gtm.push(event);
}
export function clickEnviarRecuperarContrasena(is_premium, golstats) {
  let event = { event: `enviar_email_recuperar_contraseña`, is_premium, golstats };

  window.app.__vue__.$gtm.push(event);
}
/**
 *
 * BETS
 */
export function clickBtnFlujoCuentaExisteIniciarS(value, is_premium, golstats) {
  let event = { event: 'click_btn_flujo_cuenta_existe_iniciar_s', value, is_premium, golstats };
  window.app.__vue__.$gtm.push(event);
}
export function clickBtnFlujoCuentaCrearCuentaSig2(params) {
  let event = { event: 'click_btn_flujo_cuenta_crear_cuenta_sig_2', ...params };
  window.app.__vue__.$gtm.push(event);
}
export function clickLoginBlackPopUp(params) {
  let event = { event: 'login_black_popup', ...params };
  window.app.__vue__.$gtm.push(event);
}
export function clickCrearCuentaPremium(params) {
  let event = { event: 'crear_cuenta_premium', ...params };
  window.app.__vue__.$gtm.push(event);
}
export function clickBtnBlackPopupCerrar(params) {
  let event = { event: 'close_black_popup', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetCarrouselViewProfile(params) {
  let event = { event: 'ad_carrusel_ver_perfil', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetCarrouselViewStats(params) {
  let event = { event: 'ad_carrusel_ver_estadisticas', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetCarrouselNext(params) {
  let event = { event: 'ad_carrusel_siguiente', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetCarrouselBefore(params) {
  let event = { event: 'ad_carrusel_anterior', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function doBetcaliente(params) {
  let event = { event: 'realiza_apuesta_caliente', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetSelecLeague(params) {
  let event = { event: 'ad_selec_liga', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetSelecMatchday(params) {
  let event = { event: 'ad_selec_jornada', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetSelecGame(params) {
  let event = { event: 'ad_selec_partido', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function goltipsterRightBet(params) {
  let event = { event: 'goltipster_apuesta_derecha', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function goltipsterParlay(params) {
  let event = { event: 'goltipster_parlay', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function goltipsterTips(params) {
  let event = { event: 'goltipster_tips', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function goltipsterLive(params) {
  let event = { event: 'goltipster_live', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayValueBetting(params) {
  let event = { event: 'parlay_value_betting', ...params };
  window.app.__vue__.$gtm.push(event);
}
export function parlayBreakdown(params) {
  let event = { event: 'parlay_desglose', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayBreakdownSeeMore(params) {
  let event = { event: 'parlay_desglose_ver_mas', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayBreakdownSeeLess(params) {
  let event = { event: 'parlay_desglose_ver_menos', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayStrategy(params) {
  let event = { event: 'parlay_estrategia', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetTime(params) {
  let event = { event: 'ad_tiempo', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetLocality(params) {
  let event = { event: 'ad_localia', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayDetails(params) {
  let event = { event: 'parlay_detalle', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlay2Games1(params) {
  let event = { event: 'parlay_2_partidos_riesgo_bajo', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlay2Games2(params) {
  let event = { event: 'parlay_2_partidos_riesgo_medio', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlay3Games(params) {
  let event = { event: 'parlay_3_partidos_riesgo_medio', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlay4Games(params) {
  let event = { event: 'parlay_4_partidos_riesgo_alto', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetCorners(params) {
  let event = { event: 'ad_tiros_esquina', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetResult(params) {
  let event = { event: 'ad_resultado', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function RightBetGoals(params) {
  let event = { event: 'ad_goles', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsDiversification(params) {
  let event = { event: 'tips_diversificacion', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsBreakdown(params) {
  let event = { event: 'tips_desglose', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsBreakdownSeeMore(params) {
  let event = { event: 'tips_ver_mas', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsBreakdownSeeLess(params) {
  let event = { event: 'tips_ver_menos', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsStrategy(params) {
  let event = { event: 'tips_estrategia', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function parlayBetAmount(params) {
  let event = { event: 'parlay_apostando_monto', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsBetAmount(params) {
  let event = { event: 'tips_apostando_monto', ...params };
  window.app.__vue__.$gtm.push(event);
}
export function tipsDetails(params) {
  let event = { event: 'tips_ver_detalle', ...params };
  window.app.__vue__.$gtm.push(event);
}

export function tipsSimulator(params) {
  let event = { event: 'tips_simulador', ...params };
  window.app.__vue__.$gtm.push(event);
}
// Register
/**
 * @author Fernando Mellone
 * @param {Boolean} value
 * @return {{}}
 */

export function clickBtnFlujoCuentaCrearCuentaSig(value) {
  let event = { event: 'click_btn_flujo_cuenta_crear_cuenta_sig', value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Boolean} value
 * @return {{}}
 */

// export function clickBtnFlujoCuentaExisteIniciarS(value) {
//   let event = { event: 'click_btn_flujo_cuenta_existe_iniciar_s', value };

//   window.app.__vue__.$gtm.push(event);
// }

// SelectPlan
/**
 * @author Fernando Mellone
 * @param {String} value
 * @return {{}}
 */

export function clickBtnFlujoCuentaSeleccionarPlan(value) {
  let event = { event: 'click_btn_flujo_cuenta_seleccionar_plan', value };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {Number} plan_id
 * @param {String} plan_name
 * @param {Number} plan_price
 * @param {String} plan_currency
 * @return {{}}
 */

export function clickBtnFlujoCuentaSeleccionar(plan_id, plan_name, plan_price, plan_currency) {
  let event = { event: 'click_btn_flujo_cuenta_seleccionar', plan_id, plan_name, plan_price, plan_currency };

  window.app.__vue__.$gtm.push(event);
}

// AvailablePlans
/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnPlanesDisponiblesCancelar() {
  let event = { event: 'click_btn_planes_disponibles_cancelar' };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @param {String} plan_name
 * @return {{}}
 */

export function clickBtnPlanesDisponiblesPorNombre(plan_name) {
  let event = { event: `click_btn_planes_disponibles_${plan_name}` };

  window.app.__vue__.$gtm.push(event);
}

// Profile/Settings/Index
/**
 * @author Fernando Mellone
 * @param {String} route_name
 * @return {{}}
 */

export function clickBtnPorRuta(route_name) {
  let event = { event: `click_btn_${route_name}` };

  window.app.__vue__.$gtm.push(event);
}

// PaymentMethods
/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnMetodoDePagoPrincipal() {
  let event = { event: `click_btn_metodo_de_pago_principal` };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone
 * @return {{}}
 */

export function clickBtnMetodoDePagoEliminar() {
  let event = { event: `click_btn_metodo_de_pago_eliminar` };

  window.app.__vue__.$gtm.push(event);
}

/**
 * @author Fernando Mellone

 * @return {{}}
 */

export function clickBtnMetodoDePagoAgregarTarjeta() {
  let event = { event: `click_btn_metodo_de_pago_agregar_tarjeta` };

  window.app.__vue__.$gtm.push(event);
}
